<div class="header">
  <h3>Pliki</h3>
  <lib-button [matMenuTriggerFor]="menu" icon-only>
    <mat-icon>more_vert</mat-icon>
  </lib-button>
  <mat-menu #menu="matMenu">
    <button (click)="downloadAll()" mat-menu-item>Pobierz wszystkie</button>
  </mat-menu>
</div>
@for (attachment of attachments; track attachment; let i = $index) {
  <div class="file">
    @switch (attachment.type) {
      @case ('image/jpeg') {
        <ng-container *ngTemplateOutlet="image"></ng-container>
      }
      @case ('image/png') {
        <ng-container *ngTemplateOutlet="image"></ng-container>
      }
      @default {
        <h1 (click)="downloadFile(i)">
          {{ attachment.extension }}
        </h1>
      }
    }
  </div>
  <ng-template #image
    ><img
    (click)="openImage(i)"
    *libShowOnlyWhenVisible
      [src]="
        { photoId: i + '-' + messageId }
          | getImageUrl: messageId:'anyone':context:messageId + '-' + date:150
          | async
      "
  /></ng-template>
}
